import { Card, BlockStack, Text, TextField } from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";
import { GenerativeTextField } from "@shared/ui";
import { EventSlugField } from "@shared/ui";
import { Venue } from "@features/events/types";

interface OverviewCardProps {
  venueData: Partial<Venue>;
  fieldErrors: Record<string, string>;
  hcc: string | undefined;
  onDataChange: (updates: Partial<Venue>) => void;
}

export default function OverviewCard({
  venueData,
  fieldErrors,
  hcc,
  onDataChange,
}: OverviewCardProps) {
  const { t } = useTranslation();

  return (
    <Card>
      <BlockStack gap="400">
        <Text as="h2" variant="headingMd">
          {t('venues.details.section.overview')}
        </Text>

        <GenerativeTextField
          id="name"
          placementId="event.venue.name"
          label={t('venues.details.field.title.label')}
          value={venueData.name || {}}
          onChange={(value) => onDataChange({ name: value })}
          requiredIndicator
          error={fieldErrors.name}
          type="textField"
          canGenerate={false}
        />

        <GenerativeTextField
          id="description"
          placementId="event.venue.description"
          label={t('venues.details.field.description.label')}
          value={venueData.description || {}}
          onChange={(value) => onDataChange({ description: value })}
          requiredIndicator
          error={fieldErrors.description}
          type="textArea"
          canGenerate={true}
        />

        <EventSlugField
          value={venueData.slug || ""}
          onChange={(value) => onDataChange({ slug: value })}
          healthcareCompanyId={hcc || null}
          entityId={venueData.id}
          entityType="venue"
          requiredIndicator
        />

        <TextField
          label={t('venues.details.field.max_capacity.label')}
          type="number"
          value={venueData.maxCapacity?.toString() || ""}
          onChange={(value) =>
            onDataChange({ maxCapacity: parseInt(value) || 0 })
          }
          error={fieldErrors.maxCapacity}
          helpText={t('venues.details.field.max_capacity.help_text')}
          requiredIndicator
          autoComplete="off"
        />
      </BlockStack>
    </Card>
  );
}
